import script from "./groupList.vue?vue&type=script&setup=true&lang=ts"
export * from "./groupList.vue?vue&type=script&setup=true&lang=ts"

import "./groupList.vue?vue&type=style&index=0&id=772ea59c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-772ea59c"]])

export default __exports__